






















import Vue from "vue";

// Components
import FiltersCard from "@/views/App/CashFlow/UsersBalance/FiltersCard.vue";
import ReportTableCard from "@/views/App/CashFlow/UsersBalance/ReportTableCard.vue";
import TotalsCard from "@/views/App/CashFlow/UsersBalance/TotalsCard.vue";

// Model
import menu from "@/store/modules/ApplicationModule/data/menu";
import { GetUsersBalanceReportReqData } from "@/model/communication/usersBalance/GetUsersBalanceReportReqData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetUsersBalanceReportResData } from "@/model/communication/usersBalance/GetUsersBalanceReportResData";
import { GetUsersBalanceReportCommand } from "@/model/communication/usersBalance/GetUsersBalanceReportCommand";
import { ExportUsersBalanceCommand } from "@/model/communication/usersBalance/ExportUsersBalanceCommand";

export default Vue.extend({
    components: {
        FiltersCard,
        ReportTableCard,
        TotalsCard,
    },
    data() {
        return {
            filters: null,
            availableGroups: [],
            availableShiftNumbers: [],
            usersBalanceReportEntries: [],
            usersBalanceReportTotals: null,
            loading: false,
            analizedTransactionsCount: -1,
        };
    },
    computed: {
        menuEntry() {
            return menu.find((m) => m.name == "Cash Flow").children.find((c) => c.name == "Users Balance");
        },
    },
    methods: {
        async GetUsersBalance() {
            try {
                if (!this.loading) {
                    this.loading = true;
                    let res: GetUsersBalanceReportResData = await new GetUsersBalanceReportCommand((this.filters as GetUsersBalanceReportReqData).GetReqDataPayload()).execute();

                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        this.availableGroups = res.availableGroups;
                        this.availableShiftNumbers = res.availableShiftNumbers;
                        this.usersBalanceReportEntries = res.usersBalanceReportEntries;
                        this.usersBalanceReportTotals = res.usersBalanceReportTotals;
                        this.analizedTransactionsCount = res.analizedTransactionsCount;
                    }
                    this.loading = false;
                }
            } catch (error) {
                console.error("GetUsersBalance(): ", error);
                this.loading = false;
            }
        },

        async onDownload(exportType) {
            console.log("Download required, exportType: ", exportType);
            try {
                if (!this.loading) {
                    this.loading = true;
                    const res = await new ExportUsersBalanceCommand((this.filters as GetUsersBalanceReportReqData).GetReqDataPayload(), exportType).execute();

                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.loading = false;
                }
            } catch (e) {
                console.log("Something went wrong during ExportUsersBalanceCommand execution: ", e);
                this.loading = false;
            }
        },
    },
    mounted() {
        this.filters = new GetUsersBalanceReportReqData();
    },
});
